module.exports = "var React = require('react');\r\n\r\n// Some generic abstraction of the store\r\nvar AppStore = require('MyStore');\r\n\r\nvar User = React.createClass({\r\n  render: function(){\r\n    var userData = AppStore.tiles[ this.props.layout.id ];\r\n    return <UserData user={ userData } />;\r\n  }\r\n});\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./snippets/tileId.html
 ** module id = 275
 ** module chunks = 0
 **/